

import axios from "axios";
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

export const bulkCartService = {
  addCart: async (data: { PhoneNumber: string | null; SKU_ID: string; quantity: number; Type:"ndp" | "sales" }) => {
    const response = await axios.post(`${API_BASE_URL}/bulkOrder/cart/add`, data);
    return response.data;
  },

  updateQuantity: async (data: { PhoneNumber: string | null; SKU_ID: string; quantity: number }) => {
    const response = await axios.post(`${API_BASE_URL}/bulkOrder/cart/update_quantity`, data);
    return response.data;
  },

  fetchCart: async (PhoneNumber: string | null) => {
    const response = await axios.get(`${API_BASE_URL}/bulkOrder/cart/fetch/${PhoneNumber}`);
    return response.data;
  },

  removeCart: async (PhoneNumber: string | null, SKU_ID: string) => {
    const response = await axios.get(`${API_BASE_URL}/bulkOrder/cart/remove/${PhoneNumber}/${SKU_ID}`);
    return response.data;
  },
};

